import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../base/models'
import { IPkBank } from '../models/models'

export class GetPkBankListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/pesineKontrat/bankList',
      requesterInfo,
    })
  }

  // posType: 1 = Normal POS (Banks.Flags = 1), 3 = AkÖde (Banks.Flags = 3)
  public async getBanks(posType: number): Promise<IPkBank[]> {
    this.props.url = `${this.props.url}?posType=${posType}`
    return await this.getAsync<IPkBank[]>()
  }
}
